import { render, staticRenderFns } from "./CreateNewAccount.vue?vue&type=template&id=74fbcbb9&scoped=true&"
import script from "./CreateNewAccount.vue?vue&type=script&lang=js&"
export * from "./CreateNewAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewAccount.vue?vue&type=style&index=0&id=74fbcbb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fbcbb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
